// Constantes compartidas del tablero de tareas (tipos/estados/prioridad) —
// spec "emergent-spec-tablero-tareas-agentes.md" 2026-10-25.
export const TYPE_META = {
  audit_finding: { label: "Hallazgo de auditoría", color: "bg-rose-100 text-rose-700 dark:bg-rose-900/40 dark:text-rose-300" },
  dev_request: { label: "Petición de desarrollo", color: "bg-sky-100 text-sky-700 dark:bg-sky-900/40 dark:text-sky-300" },
  director_decision: { label: "Decisión del Director", color: "bg-violet-100 text-violet-700 dark:bg-violet-900/40 dark:text-violet-300" },
  pm_task: { label: "Tarea", color: "bg-slate-100 text-slate-700 dark:bg-slate-800 dark:text-slate-300" },
  grant_call: { label: "Convocatoria", color: "bg-amber-100 text-amber-700 dark:bg-amber-900/40 dark:text-amber-300" },
};

export const STATUS_META = {
  backlog: { label: "Backlog", header: "text-slate-600 dark:text-slate-400 bg-slate-100 dark:bg-slate-800", border: "border-slate-200 dark:border-slate-700" },
  todo: { label: "Por hacer", header: "text-sky-700 dark:text-sky-400 bg-sky-100 dark:bg-sky-900/40", border: "border-sky-200 dark:border-sky-800" },
  in_progress: { label: "En curso", header: "text-amber-700 dark:text-amber-400 bg-amber-100 dark:bg-amber-900/40", border: "border-amber-200 dark:border-amber-800" },
  blocked: { label: "Bloqueada", header: "text-red-700 dark:text-red-400 bg-red-100 dark:bg-red-900/40", border: "border-red-200 dark:border-red-800" },
  in_review: { label: "En revisión", header: "text-purple-700 dark:text-purple-400 bg-purple-100 dark:bg-purple-900/40", border: "border-purple-200 dark:border-purple-800" },
  done: { label: "Hecha", header: "text-green-700 dark:text-green-400 bg-green-100 dark:bg-green-900/40", border: "border-green-200 dark:border-green-800" },
  cancelled: { label: "Cancelada", header: "text-slate-500 bg-slate-50 dark:bg-slate-900/40", border: "border-slate-200 dark:border-slate-800" },
};

export const BOARD_COLUMNS = ["backlog", "todo", "in_progress", "blocked", "in_review", "done"];

export const PRIORITY_META = {
  P0: { label: "P0 · Urgente", color: "bg-red-600 text-white" },
  P1: { label: "P1 · Alta", color: "bg-orange-500 text-white" },
  P2: { label: "P2 · Media", color: "bg-sky-500 text-white" },
  P3: { label: "P3 · Baja", color: "bg-slate-400 text-white" },
};

export const actorLabel = (actor) => {
  if (!actor) return null;
  return actor.name || actor.id;
};
